/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class InspectionProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	async getInspectionFromDocumentID(pDocumentID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pDocumentID)
			{
				this.pict.log.error('No Document ID provided.');
				return reject(new Error('No Document ID provided.'));
			}
			this.fable.HeadlightRestClient.getJSON(`Inspections/FilteredTo/FBV~InspectionDocumentJoin.IDDocument~EQ~${ pDocumentID }/0/100?Joins=InspectionDocumentJoin,IDInspection,IDInspection;`,
				(pError, pResponse) =>
				{
					if (pError)
					{
						this.log.error('Error loading Inspection from Document:', pError);
						return reject(pError);
					}
					if (pResponse?.length)
					{
						this.pict.AppData.CurrentInspection = pResponse[0];
					}
					if (!this.pict.AppData.CurrentInspection)
					{
						this.log.warn(`No Current Inspection set. Can't load Inspection Documents.`);
						this.AppData.InspectionDocumentRecords = [];
						this.AppData.CachedInspectionDocumentRecordsIDInspection = 0;
						return resolve();
					}
					const currentInspectionID = this.pict.AppData.CurrentInspection.IDInspection;
					const cachedInspectionID = this.pict.AppData.CachedInspectionDocumentRecordsIDInspection;
					if ('InspectionDocumentRecords' in this.pict.AppData && currentInspectionID == cachedInspectionID)
					{
						return resolve(currentInspectionID);
					}
					delete this.AppData.InspectionDocumentRecords;
					delete this.AppData.CachedInspectionDocumentRecordsIDInspection;
					resolve(currentInspectionID);
				});
		});
	}

	async getInspectionDocumentJoins(inspectionID)
	{
		await new Promise((resolve, reject) =>
		{
			return this.pict.providers.EntityInspectionDocumentProvider.loadRecordsToAddress((error) =>
			{
				if (error)
				{
					this.log.warn(`Error retrieving Documents for Inspection ID ${inspectionID}:`, error);
					return reject(error);
				}
				resolve();
			}, 'AppData.InspectionDocumentJoins', `FilteredTo/FBV~IDInspection~EQ~${inspectionID}`, 0, 100);
		});
	}

	async getInspectionTypes()
	{
		await new Promise((resolve, reject) =>
		{
			if (Array.isArray(this.pict.AppData.InspectionTypes))
			{
				this.pict.log.info('InspectionTypes loaded', this.pict.AppData.InspectionTypes);
				return resolve();
			}
			// todo: do inspection types exist by default? this may need a fallback
			return this.pict.providers.EntityInspectionTypeProvider.loadRecordsToAddress((error) =>
			{
				if (error)
				{
					this.log.warn(`Error retrieving Inspection Types`, error);
					return reject(error);
				}
				resolve();
			}, 'AppData.InspectionTypes', null, null, null);
		});
	}

	async getCurrentInspectionDocumentRecords(inspectionID)
	{
		await new Promise((resolve, reject) =>
		{
			if (this.pict.AppData.InspectionDocumentJoins.length < 1)
			{
				// no need to hit server for nothing
				this.pict.AppData.CachedInspectionDocumentRecordsIDInspection = inspectionID;
				this.pict.AppData.InspectionDocumentRecords = [];
				return resolve();
			}

			const documentIds = this.pict.AppData.InspectionDocumentJoins.map((pJoin) => pJoin.IDDocument).join(',');

			return this.pict.providers.EntityDocumentProvider.loadRecordsToAddress(() =>
			{
				this.pict.AppData.CachedInspectionDocumentRecordsIDInspection = inspectionID;
				this.AppData.InspectionDocumentRecords.forEach((d) =>
				{
					//FIXME: zzzz - propagating include bit from join record to document record for UI, for now
					const join = this.AppData.InspectionDocumentJoins.find((pJoin) => pJoin.IDDocument == d.IDDocument);
					d.IncludeOnDossier = join ? join.IncludeOnDossier : 0;
					d.Ordinal = join ? join.Ordinal : this.AppData.InspectionDocumentJoins.length;

					const timeDelta = Math.abs(new Date().getTime() - new Date(join.CreateDate).getTime());
					// doc was added within 1 minute of rendering this screen. Probably from current user's action.
					d.NewlyAdded = timeDelta <= 60000;
				});
				this.AppData.InspectionDocumentRecords.sort((a, b) => a.Ordinal - b.Ordinal);
				resolve();
			}, 'AppData.InspectionDocumentRecords', `FilteredTo/FBL~IDDocument~INN~${documentIds}`, 0, this.AppData.InspectionDocumentJoins.length);
		});
	}

	async getCurrentInspectionDocuments(pDocumentID)
	{
		return new Promise(async (resolve, reject) =>
		{
			if (!pDocumentID)
			{
				this.pict.log.warn('No Document ID provided. Returning empty Inspection Documents.');
				this.AppData.InspectionDocumentRecords = [];
				this.AppData.CachedInspectionDocumentRecordsIDInspection = 0;
				return resolve();
			}

			// If the InspectionDocumentRecords are already loaded and match the current inspection, return them
			if (this.AppData.InspectionDocumentRecords && this.AppData.CachedInspectionDocumentRecordsIDInspection == this.pict.AppData.CurrentInspection?.IDInspection)
			{
				this.pict.log.info('Returning cached Inspection Documents for Document ID:', pDocumentID);
				return resolve();
			}

			try
			{
				await this.getInspectionTypes();
				const inspectionID = await this.getInspectionFromDocumentID(pDocumentID);
				if (!inspectionID)
				{
					this.pict.log.warn('No Inspection ID found for Document ID:', pDocumentID);
					this.AppData.InspectionDocumentRecords = [];
					this.AppData.CachedInspectionDocumentRecordsIDInspection = 0;
					return resolve();
				}
				await this.getInspectionDocumentJoins(inspectionID);
				await this.getCurrentInspectionDocumentRecords(inspectionID);
				resolve();
			}
			catch (pError)
			{
				this.pict.log.error(`Error retrieving Inspection Document Record for document id ${pDocumentID}:`, pError);
				reject(pError);
			}
		});
	}
}

module.exports = InspectionProvider;
module.exports.default_configuration = {};
